import { CREATE_NEW_COLLECTION_KEY } from "@/modules/snapshots/modals/generateSnapshotCollectionModal/consts";
import { SnapshotCollection, SnapshotCollectionExecutionMode } from "@/modules/snapshots/snapshotCollection.types";
import { UseFormSetError } from "react-hook-form";

export const getSnapshotCollectionOptions = (snapshotCollections: SnapshotCollection[]) => [
  ...snapshotCollections
    .map(row => ({
      label: row.name,
      value: row.id,
    }))
    .sort((a, b) => a.label.localeCompare(b.label)),
  {
    label: "Create new collection",
    value: CREATE_NEW_COLLECTION_KEY,
  } as const,
];

export const validateSnapshotCollection = (
  selectedSnapshotCollection: string,
  payload: { snapshot_collection_new: string },
  setError: UseFormSetError<{ snapshot_collection_new: string }>,
) => {
  if (selectedSnapshotCollection === CREATE_NEW_COLLECTION_KEY && !payload.snapshot_collection_new) {
    setError("snapshot_collection_new", {
      type: "custom",
      message: "New snapshot collection name is required",
    });
    return false;
  }
  return true;
};

/**
 * The execution mode an existing collection is locked to, or null when the user may still
 * choose (new collection, or one that has not started running yet). Mirrors the backend rule
 * in SnapshotCollectionCreateProcess: the mode is only changeable while status is NEW.
 */
export const getLockedExecutionMode = (
  snapshotCollections: SnapshotCollection[],
  selectedSnapshotCollection: string | undefined,
): SnapshotCollectionExecutionMode | null => {
  if (!selectedSnapshotCollection || selectedSnapshotCollection === CREATE_NEW_COLLECTION_KEY) return null;
  const collection = snapshotCollections.find(row => row.id === selectedSnapshotCollection);
  if (!collection || collection.status === "NEW") return null;
  return collection.execution_mode ?? "sync";
};
